import { render, staticRenderFns } from "./ChatUserItemContainer.vue?vue&type=template&id=c5566bb8&"
import script from "./ChatUserItemContainer.vue?vue&type=script&lang=js&"
export * from "./ChatUserItemContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports